import React from 'react'
// import { useNavigate } from 'react-router-dom';
// import { Button } from '@material-tailwind/react';

const ErrorPage = () => {
  // const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-10">
    <h1 className="text-2xl ">Uh oh, something went terribly wrong</h1>
    <p className="w-2/3 text-center">
      Error message: ""
    </p>
    {/* <Button
      type="button"
      color="teal"
      onClick={() => {
        navigate('/');
      }}
    >
      Click here to reload the app
    </Button> */}
  </div>
  )
}

export default ErrorPage
